var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ssr-page",class:[
    _vm.lang,
    { landscape: _vm.isLandscape, 'transparent-bg-mode': _vm.isTransparentBgMode }
  ],attrs:{"id":"ssr-page"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }